// ==========================
// src/components/Navbar.jsx (responsive con Drawer para móvil)
// ==========================
import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Box, IconButton, Drawer, List, ListItemButton, ListItemText, Divider, Stack } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// Si tu SVG da problemas con SVGR, usa la alternativa con <img> comentada abajo
import { ReactComponent as Logo } from '../assets/logo.svg';
// import logoUrl from '../assets/logo.svg'; // alternativa si no usas SVGR

const NAV_ITEMS = [
  { label: 'Inicio', id: 'inicio' },
  { label: 'Quiénes somos', id: 'quienes' },
  { label: 'Misión & Visión', id: 'mision-vision' },
  { label: 'Ubicación', id: 'ubicacion' },
];

export default function Navbar(){
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleGo = (id) => {
    scrollTo(id);
    setOpen(false);
  };

  return (
    <AppBar position="sticky" color="inherit" className="appbar-elevated">
      <Container>
        <Toolbar disableGutters sx={{ py: 1 }}>
          {/* Marca */}
          <Box
            onClick={() => scrollTo('inicio')}
            sx={{ display:'flex', alignItems:'center', gap: 1, mr: 2, cursor:'pointer', color: 'primary.main' }}
            aria-label="Ángel de Oro — Inicio"
          >
            <Logo style={{ height: 40, width: 'auto', display:'block' }} />
            {/* <Box component="img" src={logoUrl} alt="Ángel de Oro" sx={{ height: 40, width: 'auto', display:'block' }} /> */}
          </Box>

          {/* Navegación escritorio */}
          <Box sx={{ ml: 'auto', display:{ xs:'none', md:'flex' }, alignItems:'center', gap: 1 }}>
            {NAV_ITEMS.map(it => (
              <Button key={it.id} onClick={() => handleGo(it.id)} color="inherit">{it.label}</Button>
            ))}
            <Button variant="contained" sx={{ ml: 1 }} onClick={() => handleGo('contacto')}>Contacto</Button>
          </Box>

          {/* Botón menú móvil */}
          <IconButton
            aria-label="Abrir menú"
            onClick={() => setOpen(true)}
            sx={{ ml: 'auto', display:{ xs:'inline-flex', md:'none' } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </Container>

      {/* Drawer móvil */}
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 300, display:'flex', flexDirection:'column', height:'100%' }} role="presentation">
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2 }}>
            <Box sx={{ display:'flex', alignItems:'center', gap: 1, color:'primary.main' }} onClick={() => handleGo('inicio')}>
              <Logo style={{ height: 28, width: 'auto', display:'block' }} />
              {/* <Box component="img" src={logoUrl} alt="Ángel de Oro" sx={{ height: 28, width: 'auto', display:'block' }} /> */}
            </Box>
            <IconButton aria-label="Cerrar" onClick={() => setOpen(false)}>
              <CloseRoundedIcon />
            </IconButton>
          </Stack>
          <Divider />
          <List>
            {NAV_ITEMS.map(it => (
              <ListItemButton key={it.id} onClick={() => handleGo(it.id)}>
                <ListItemText primary={it.label} />
              </ListItemButton>
            ))}
            <Box sx={{ p: 2 }}>
              <Button fullWidth variant="contained" onClick={() => handleGo('contacto')}>Contacto</Button>
            </Box>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
}